import Finish from "@/modules/finish/pages/Finish.vue";

export default [
  {
    path: "/finish",
    name: "finish",
    component: Finish,
  },
];
